import React, { useEffect, useState } from 'react';
import { FileText } from 'lucide-react';
import { base44 } from '@/api/base44Client';
import { useAuth } from '@/lib/AuthContext';
import { isAdminOrOwner } from '@/lib/roles';
import AppHeader from '@/components/drill/AppHeader';
import { cloud } from '@/backend';
import { store } from '@/storage/sqliteStore';
import { getActiveTenantId } from '@/lib/tenantContext';

const FIELD_LABELS = { hole_id:'Hole ID', rig_id:'Rig', method:'Drilling Method', status:'Hole Status', current_depth:'Current Depth', run_count:'Run Count', today_drilled:"Today's Metres", last_run_from:'Last Run From', last_run_to:'Last Run To', date:'Current Date' };

export default function Documents() {
  const { effectiveRole } = useAuth();
  const [docs, setDocs] = useState([]);
  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const user = await base44.auth.me();
        const org = await getActiveTenantId().catch(() => user?.organisation_id || user?.organization_id || user?.org_id);
        if (org && cloud.isEnabled()) {
          const remote = await cloud.pullOrganisationRecords(org, ['DocumentTemplate']);
          for (const record of remote) { if (!record.deleted && record.payload) await store('DocumentTemplate').put(record.payload); }
        }
        const rows = await base44.entities.DocumentTemplate.list('-updated_date');
        if (active) setDocs(rows || []);
      } catch { if (active) setDocs([]); }
    })();
    return () => { active = false; };
  }, []);
  const visible = docs.filter((d) => isAdminOrOwner(effectiveRole) || (d.permissions || []).includes(effectiveRole));
  return <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 dark:from-slate-950 dark:to-slate-900">
    <AppHeader title="Documents" subtitle="Organisation documents available to your role" backTo="/" />
    <main className="max-w-4xl mx-auto px-4 sm:px-6 py-6 pb-24 space-y-4">
      {!visible.length && <div className="rounded-2xl border bg-white p-8 text-center dark:bg-slate-900 dark:border-slate-800"><FileText className="w-10 h-10 mx-auto text-slate-300" /><p className="mt-3 font-medium">No documents available</p></div>}
      {visible.map((doc) => <article key={doc.id} className="rounded-2xl border bg-white p-5 dark:bg-slate-900 dark:border-slate-800"><div className="flex items-center justify-between gap-3"><div><h2 className="font-semibold text-lg">{doc.title}</h2>{doc.description && <p className="text-sm text-slate-500 mt-1">{doc.description}</p>}</div><span className="text-xs text-slate-400">v{doc.version || 1}</span></div><div className="mt-4 space-y-3">{(doc.blocks || []).map((b) => b.type === 'heading' ? <h3 key={b.id} className="font-semibold">{b.text}</h3> : b.type === 'field' ? <div key={b.id} className="rounded-xl bg-slate-50 px-3 py-2 text-sm dark:bg-slate-800"><span className="text-slate-500">{FIELD_LABELS[b.field] || b.field}</span></div> : <p key={b.id} className="text-sm whitespace-pre-wrap">{b.text}</p>)}</div></article>)}
    </main>
  </div>;
}
